import { Model } from 'vue-models'
import Vessel from '../vessel'

export default class ConventionalShipment extends Model {
  static defaults () {
    return {
      name: 'shipment'
    }
  }
  static schema () {
    return {
      id: { type: Number },
      milestone: { type: Number },
      ais_status: { type: Number },
      vessel: { type: Vessel },
      current_position: { type: Object },
      previous_positions: { type: Array },
      next_stage: { type: Object },
      current_stage: { type: Object }
    }
  }
  static VESSEL_STATUS = {
    0: 'Under way using engine',
    1: 'At anchor',
    2: 'Not under command',
    3: 'Restricted manoeuverability',
    4: 'Constrained by her draught',
    5: 'Moored',
    6: 'Aground',
    7: 'Engaged in Fishing',
    8: 'Under way sailing',
    9: 'Reserved for future amendment of Navigational Status for HSC',
    10: 'Reserved for future amendment of Navigational Status for WIG',
    14: 'AIS-SART is active',
    15: 'Not defined (default)'
  }
  static MILESTONE = {
    '-1': 'unknown',
    100: 'in POL terminal',
    200: 'ocean transport to TSP',
    250: 'in TSP terminal',
    300: 'ocean transport to POD',
    350: 'in POD terminal',
    400: 'land transport to Place of Delivery',
    1000: 'completed'
  }
  static TYPE_VESSEL = {
    0: 'Not available (default)',
    20: 'Wing in ground',
    30: 'Fishing',
    31: 'Towing',
    32: 'Towing: length exceeds 200m or breadth exceeds 25m',
    33: 'Dredging or underwater ops',
    34: 'Diving ops',
    35: 'Military ops',
    36: 'Sailing',
    37: 'Pleasure Craft',
    40: 'High speed craft',
    50: 'Pilot Vessel',
    51: 'Search and Rescue vessel',
    52: 'Tug',
    53: 'Port Tender',
    54: 'Anti-pollution equipment',
    55: 'Law Enforcement',
    56: 'Spare - Local Vessel',
    57: 'Spare - Local Vessel',
    58: 'Medical Transport',
    59: 'Noncombatant ship',
    60: 'Passenger',
    70: 'Cargo',
    80: 'Tanker',
    90: 'Other Type'
  }

  static SHIPMENT_TYPE = {
    'pol': 'Port of Loading',
    'pod': 'Port of Discharge',
    'tsp': 'Transhipment'

  }
}



// WEBPACK FOOTER //
// ./src/models/conventional/shipment.js